<div class="min-h-screen bg-gray-50">
  <header class="relative">
    <div class="w-full h-20 bg-primary"></div>
    <div
      class="relative z-10 -mt-8 bg-white px-8 pt-5 pb-12 rounded-t-[2rem] flex flex-col md:flex-row md:items-center md:justify-between gap-6"
    >
      <div
        *ngIf="!isLoading; else skeletonProfile"
        class="flex flex-col items-center md:items-start relative md:flex-row"
      >
        <div
          class="absolute -top-8 left-1/2 transform -translate-x-1/2 md:static md:translate-x-0 md:transform-none md:mr-6 md:flex-shrink-0"
        >
          <img
            [src]="userImage"
            alt="Foto de perfil"
            class="w-32 h-32 rounded-full border-4 border-white shadow-lg object-cover"
          />
          <button
            (click)="openModalUploadImage()"
            type="button"
            class="flex absolute items-center bottom-0 right-0 justify-center bg-primary text-white rounded-full h-8 w-8 shadow-md hover:scale-105 transition-transform"
          >
            <ng-icon name="heroPencil" size="20"></ng-icon>
          </button>
        </div>
        <div class="mt-28 md:mt-8 text-center md:text-left w-full md:ml-0">
          <h1 class="text-2xl font-bold text-gray-900">
            {{ profile.firstName }} {{ profile.lastName }}
          </h1>
          <p class="text-gray-500">{{ profile.email }}</p>
        </div>
      </div>
      <ng-template #skeletonProfile>
        <div
          class="flex flex-col items-center md:items-start relative md:flex-row animate-pulse"
        >
          <div
            class="absolute -top-8 left-1/2 transform -translate-x-1/2 md:static md:translate-x-0 md:transform-none md:mr-6 md:flex-shrink-0"
          >
            <div
              class="w-32 h-32 rounded-full border-4 border-white shadow-lg bg-gray-300"
            ></div>
          </div>
          <div class="mt-28 md:mt-0 text-center md:text-left w-full md:ml-0">
            <div
              class="h-6 w-48 bg-gray-300 rounded mb-2 mx-auto md:mx-0"
            ></div>
            <div class="h-4 w-64 bg-gray-200 rounded mx-auto md:mx-0"></div>
          </div>
        </div>
      </ng-template>
      <div class="flex flex-col md:items-end w-full md:w-auto">
        <div class="flex space-x-3 items-center mt-4 md:mt-0">
          <a
            [href]="profile.urlPersonalFile || '#'"
            target="_blank"
            class="flex items-center px-4 py-2 rounded-md bg-gray-800 text-white hover:bg-gray-700 gap-2 shadow"
            [class.opacity-50]="!profile.urlPersonalFile"
            [class.pointer-events-none]="!profile.urlPersonalFile"
            [attr.tabindex]="!profile.urlPersonalFile ? -1 : null"
          >
            <span>Ver CV</span>
            <ng-icon name="featherExternalLink" size="20"></ng-icon>
          </a>
          <button
            (click)="toggleEditFile()"
            class="border border-primary rounded-md text-primary p-2 shadow flex items-center justify-center transition-transform duration-200 transform hover:scale-105 cursor-pointer"
          >
            <ng-icon name="heroPencil" size="20"></ng-icon>
          </button>
        </div>
        <div
          *ngIf="editingFile"
          class="flex flex-col mt-2 md:absolute md:bottom-0 md:right-5 items-center space-y-2 md:flex-row md:space-y-0 md:space-x-2 w-full md:w-auto"
        >
          <input
            type="url"
            [(ngModel)]="personalFileUrl"
            #cvUrl="ngModel"
            placeholder="Ingrese URL de su CV"
            class="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary transition"
            required
            pattern="https?://.+"
          />
          <app-loading-button
            [text]="'Actualizar'"
            [loading]="isUpdatingFile"
            type="button"
            (click)="savePersonalFile()"
            class="w-full md:w-auto"
          >
          </app-loading-button>
        </div>
      </div>
    </div>
  </header>
  <nav class="bg-white border-b border-gray-200 px-16">
    <ul class="flex space-x-10 px-4 py-2 text-gray-600 font-medium">
      <li>
        <a
          routerLink="/user/detail"
          routerLinkActive="border-b-2 border-primary font-medium text-primary"
          [routerLinkActiveOptions]="{ exact: true }"
          class="flex items-center gap-2 pb-2 hover:text-primary transition-colors"
        >
          Perfil
          <ng-icon name="featherUser" size="20"></ng-icon>
        </a>
      </li>
      <li>
        <a
          routerLink="/user/detail/experience"
          routerLinkActive="border-b-2 border-primary font-medium text-primary"
          class="flex items-center gap-2 pb-2 hover:text-primary transition-colors"
        >
          Experiencia
          <ng-icon name="featherAward" size="20"></ng-icon>
        </a>
      </li>
    </ul>
  </nav>
  <main class="px-2 md:px-20 py-4 bg-light">
    <router-outlet></router-outlet>
  </main>
</div>
<app-image-upload-modal
  *ngIf="showModalUpdate"
  [loading]="modalLoading"
  (close)="showModalUpdate = false"
  (imageSelected)="uploadLogo($event)"
></app-image-upload-modal>
